import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';
import auth from "../../../common/utility/auth";

import {
    PROY_AGRO
} from "../../../common/types/parametroType";


import fenologicaService from '../../../service/administracion/fenologicaService';
import cultivoService from '../../../service/administracion/cultivoService';

import Header from './Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import CargaMasivaModal from './CargaMasivaModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            loadingSearch: false,

            visibleCargaMasiva: false,
            cultivos: [],
            estados: estadoMock.values,
            filter: {
                nombre: "",
                idCultivo: 0,
                estado: '',
                activeKey: "1",
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: "",
            idCultivo: 0,
            codigoReferencia: '',
            activeKey: "1",
            cultivos: [],
            listaCargaMasiva: [],
        }
    };

    handleClearFilters = () => {
        this.setState({
            loadingSearch: true,
        });
        var filter = {
            nombre: "",
            idCultivo: 0,
            activeKey: this.state.formValues.activeKey,
            estado: '',
            ...FILTER
        };
        this.setState({ filter });
        setTimeout(() => {
            this.handleSearch();
        }, 100);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = undefined;

        response = this.state.formValues.activeKey == "1" ?
            await cultivoService.excel(this.state.filter) : await fenologicaService.excel(this.state.filter);

        this.setState({ loadingExcel: false });
        var nombre = this.state.formValues.activeKey == "2" ? "Reporte de Etapa Fenológica.xlsx" : "Reporte de Cultivo.xlsx"

        if (response !== undefined)
            global.dowloadFile(response.data, nombre);
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = undefined;
        response = this.state.formValues.activeKey == "1" ?
            await cultivoService.pdf(this.state.filter) : await fenologicaService.pdf(this.state.filter);

        this.setState({ loadingPdf: false });
        var nombre = this.state.formValues.activeKey == "2" ? "Reporte de Etapa Fenológica.pdf" : "Reporte de Cultivo.pdf"

        if (response !== undefined)
            global.dowloadFile(response.data, nombre);
    }


    handleDeleteActive = (values) => {

        var params = auth.user().parametros;
        var flagCrear = params.filter((m) => m.abreviatura === PROY_AGRO)[0].valor === "1" ? true : false;

        if (!flagCrear) {
            message.warning('Opción no disponible.');
            return;
        }

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = this.state.formValues.activeKey == "1" ?
                    await cultivoService.eliminar(values) : await fenologicaService.eliminar(values);
            else
                response = this.state.formValues.activeKey == "1" ?
                    await cultivoService.activar(values) : await fenologicaService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this.handleChangeTab(this.state.formValues.activeKey)
                return;
            }

            if (response.status === 400) {
                dialog.warning(
                    <ul>
                        {response.data.messages.map((item) => (
                            <li>{item}</li>
                        ))}
                    </ul>
                );
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    handleNew = () => {

        var params = auth.user().parametros;
        var flagCrear = params.filter((m) => m.abreviatura === PROY_AGRO)[0].valor === "1" ? true : false;

        if (!flagCrear) {
            message.warning('Opción no disponible.');
            return;
        }
        var formValues = this.fetchEmptyFormValues();
        formValues.activeKey = this.state.formValues.activeKey;
        formValues.cultivos = this.state.cultivos;
        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {

        var params = auth.user().parametros;
        var flagCrear = params.filter((m) => m.abreviatura === PROY_AGRO)[0].valor === "1" ? true : false;

        if (!flagCrear) {
            message.warning('Opción no disponible.');
            return;
        }

        var formValues = this.fetchEmptyFormValues();
        formValues.activeKey = this.state.formValues.activeKey;
        formValues.id = values.id;
        formValues.nombre = values.nombre;
        formValues.idCultivo = values.idCultivo;
        formValues.codigoReferencia = values.codigoReferencia;
        formValues.cultivos = this.state.cultivos;
        this.setState({ visible: true, formValues });

    };

    handleNewCargaMasiva = () => {
        var params = auth.user().parametros;
        var flagCrear = params.filter((m) => m.abreviatura === PROY_AGRO)[0].valor === "1" ? true : false;

        if (!flagCrear) {
            message.warning('Opción no disponible.');
            return;
        }

        this.setState({ visibleCargaMasiva: true });
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = this.state.formValues.activeKey == "1" ?
                    await cultivoService.registrar(values) : await fenologicaService.registrar(values);
            else
                response = this.state.formValues.activeKey == "1" ?
                    await cultivoService.modificar(values) : await fenologicaService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this.handleChangeTab(this.state.formValues.activeKey);

                if (this.state.formValues.activeKey == "1") {
                    const cultivos = await cultivoService.listar();
                    this.setState({
                        loadingSource: false,
                        cultivos: cultivos ? cultivos : []
                    });
                }
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleChangeTab = async (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key,
                idTipoAtributo: key == "1" ? 1 : 2
            },
            filter: {
                ...this.state.filter,
                activeKey: key,
                estado:'',
                idTipoCampo: key == "1" ? this.state.filter.idTipoCampo : 0,
                idTipoAtributo: key == "1" ? 1 : 2

            },
        });
        setTimeout(async () => {
            if (key == "1") {
                var response = await cultivoService.paginacion({ ...this.state.filter });
                this.setState({
                    pagination: response
                })
            } else {
                var response = await fenologicaService.paginacion({ ...this.state.filter });
                this.setState({
                    pagination: response
                })
            }
            //this._handlePagination(this.state.filter);

        }, 100);
    };

    handleDownloadFormatoCargaMasiva = async () => {

        if (this.state.formValues.activeKey == "1") {
            var response = await cultivoService.formatoCargaMasiva();
            if (response !== undefined)
                global.dowloadFile(response.data, "template-carga-masiva-cultivo.xlsx");
        } else {
            var response = await fenologicaService.formatoCargaMasiva();
            if (response !== undefined)
                global.dowloadFile(response.data, "template-carga-masiva-fenologica.xlsx");
        }

    };

    handleSaveCargaMasiva = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            this.state.formValues.activeKey == "1" ?
                response = await cultivoService.registrarCargaMasiva(values) :
                response = await fenologicaService.registrarCargaMasiva(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                empty.activeKey = this.state.formValues.activeKey;
                this.setState({ visibleCargaMasiva: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();

                message.success('Registrado correctamente.');

                this.handleChangeTab(this.state.formValues.activeKey)
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleSearch = async () => {
        this.setState({
            loadingSearch: true,
        });
        if (this.state.formValues.activeKey == "1") {
            var response = await cultivoService.paginacion({ ...this.state.filter });
            this.setState({
                pagination: response
            })
        } else {
            var response = await fenologicaService.paginacion({ ...this.state.filter });
            this.setState({
                pagination: response
            })
        }
        this.setState({
            loadingSearch: false,
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, cultivoService.paginacion);
        const cultivos = await cultivoService.listar();
        this.setState({
            loadingSource: false,
            cultivos: cultivos ? cultivos : []
        });
    }

    render() {
        return (
            <div>
                <Header
                    title={this.state.formValues.activeKey == "2" ? "Etapa Fenológica" : "Cultivo"}
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    loadingSearch={this.state.loadingSearch}
                    onNewCargaMasiva={this.handleNewCargaMasiva}
                    loadingNewCargaMasiva={this.state.loadingSource}
                    onSearch={this.handleSearch}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    cultivos={this.state.cultivos}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                    onChangeTab={this.handleChangeTab}
                    formValues={this.state.formValues}

                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />

                <CargaMasivaModal
                    onDownloadFormatoCargaMasiva={this.handleDownloadFormatoCargaMasiva}
                    visible={this.state.visibleCargaMasiva}
                    formValues={this.state.formValues}
                    onUploadFile={this.state.formValues.activeKey == "1" ?
                        cultivoService.subirCargaMasiva :
                        fenologicaService.subirCargaMasiva}
                    onClose={() => this.setState({ visibleCargaMasiva: false })}
                    onSave={this.handleSaveCargaMasiva}
                />
            </div>
        );
    };
}